var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSolidW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68457 0.875C8.68457 0.391016 8.29355 0 7.80957 0C7.32559 0 6.93457 0.391016 6.93457 0.875V7.51133L4.92754 5.5043C4.58574 5.1625 4.03066 5.1625 3.68887 5.5043C3.34707 5.84609 3.34707 6.40117 3.68887 6.74297L7.18887 10.243C7.53066 10.5848 8.08574 10.5848 8.42754 10.243L11.9275 6.74297C12.2693 6.40117 12.2693 5.84609 11.9275 5.5043C11.5857 5.1625 11.0307 5.1625 10.6889 5.5043L8.68457 7.51133V0.875ZM2.55957 9.625C1.59434 9.625 0.80957 10.4098 0.80957 11.375V12.25C0.80957 13.2152 1.59434 14 2.55957 14H13.0596C14.0248 14 14.8096 13.2152 14.8096 12.25V11.375C14.8096 10.4098 14.0248 9.625 13.0596 9.625H10.2842L9.04551 10.8637C8.36191 11.5473 7.25449 11.5473 6.5709 10.8637L5.33496 9.625H2.55957ZM12.6221 11.1562C12.7961 11.1562 12.963 11.2254 13.0861 11.3485C13.2092 11.4715 13.2783 11.6385 13.2783 11.8125C13.2783 11.9865 13.2092 12.1535 13.0861 12.2765C12.963 12.3996 12.7961 12.4688 12.6221 12.4688C12.448 12.4688 12.2811 12.3996 12.158 12.2765C12.035 12.1535 11.9658 11.9865 11.9658 11.8125C11.9658 11.6385 12.035 11.4715 12.158 11.3485C12.2811 11.2254 12.448 11.1562 12.6221 11.1562Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSolidW);
export default __webpack_public_path__ + "static/media/download-solid-w.3d6898a08affc004d176de3532785aac.svg";
export { ForwardRef as ReactComponent };